import React from "react";

export default function SidebarItem({ Logo, title, desc, className = "" }) {
  return (
    <div className={`flex gap-2 ${className}`}>
      <Logo className="w-16 h-16 items-start pt-1 text-red-500" />
      <div>
        <p className="text-sm font-bold">{title}</p>
        <p className="text-sm text-gray-500">{desc}</p>
      </div>
    </div>
  );
}
